import {ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection} from '@angular/core';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BrowserModule} from '@angular/platform-browser';
import {registerLocaleData} from "@angular/common";
import {provideRouter} from "@angular/router";
import localeDE from '@angular/common/locales/de';

import {provideToastr} from "ngx-toastr";
import {BrowserCacheLocation, InteractionType, LogLevel, PublicClientApplication} from "@azure/msal-browser";
import {MsalBroadcastService, MsalGuard, MsalInterceptor, MsalModule, MsalService} from "@azure/msal-angular";

import {routes} from "./app-routes";
import {ProjectStatusPipe} from "./pipes/project-status.pipe";
import {TeamRolePipe} from "./pipes/team-role.pipe";
import {ProjectNamingPipe} from "./pipes/project-naming.pipe";

registerLocaleData(localeDE);

export function loggerCallback(logLevel: LogLevel, message: string) {
    console.log(message);
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({
            eventCoalescing: true
        }),
        provideRouter(routes),
        provideHttpClient(withInterceptorsFromDi()),
        provideToastr({
            positionClass: 'toast-top-center',
        }),
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        ProjectStatusPipe,
        TeamRolePipe,
        ProjectNamingPipe,
        importProvidersFrom(
            BrowserModule,
            BrowserAnimationsModule,
            FormsModule,
            ReactiveFormsModule,
            MsalModule.forRoot(new PublicClientApplication({
                auth: {
                    clientId: '92f61db6-70a5-4342-a18b-3e1c46287754',
                    authority: 'https://login.microsoftonline.com/8de22ded-9667-4d46-8d88-7892ae492f0b',
                    redirectUri: "/",
                    postLogoutRedirectUri: '/'
                },
                cache: {
                    cacheLocation: BrowserCacheLocation.LocalStorage,
                },
                system: {
                    loggerOptions: {
                        loggerCallback: () => {
                            return;
                        }, //loggerCallback,
                        logLevel: LogLevel.Info,
                        piiLoggingEnabled: false
                    }
                }
            }), {
                interactionType: InteractionType.Redirect, // MSAL Guard Configuration
                authRequest: {
                    scopes: ['user.read']
                },
                loginFailedRoute: '/login-failed'
            }, {
                interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
                protectedResourceMap: new Map([
                    ['https://graph.microsoft.com/v1.0/*', ['user.read']],
                    ['api/api.php', ['api://92f61db6-70a5-4342-a18b-3e1c46287754/api.access']],
                ])
            })
        ),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: LOCALE_ID,
            useValue: 'de'
        }
    ]
}
